import * as types from "./types";
import JigsawAPI from "../../services/jigsaw";
import * as selectors from "./selectors";

const fetchCollectionsRequest = () => ({
  type: types.FETCH_COLLECTIONS_REQUEST,
  loading: true
});

const fetchCollectionsSuccess = data => ({
  type: types.FETCH_COLLECTIONS_SUCCESS,
  loading: false,
  data
});

const fetchCollectionsFailure = error => ({
  type: types.FETCH_COLLECTIONS_FAILURE,
  loading: false,
  error
});

const shouldFetchCollections = state =>
  !selectors.areCollectionsLoaded(state) &&
  !selectors.isCollectionsFetching(state);

export const fetchCollections = () => async (dispatch, getState) => {
  const state = getState();
  if (shouldFetchCollections(state)) {
    dispatch(fetchCollectionsRequest());
    return JigsawAPI.getCollections()
      .then(data => {
        dispatch(fetchCollectionsSuccess(data));
      })
      .catch(error => dispatch(fetchCollectionsFailure(error)));
  }
};
